<mat-icon #triggerButton
          (mouseenter)="show()"
          (mouseleave)="hide()"
          class="icon-20 trigger-icon">help_outline</mat-icon>
